/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'heart': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10.146 4.272c1.755-1.66 4.55-1.709 6.364-.066a4.489 4.489 0 01.425 6.244l-.181.204-6.277 6.155a.677.677 0 01-.305.172l-.113.019h-.115a.691.691 0 01-.325-.114l-.093-.077-6.296-6.174a4.49 4.49 0 01.262-6.429 4.708 4.708 0 016.365.066l.103.102.015.008a.114.114 0 00.052 0l.015-.008.104-.102zm5.452.904a3.34 3.34 0 00-4.488.018l-.166.164-.12.101a1.507 1.507 0 01-1.474.097l-.17-.097-.121-.1a3.337 3.337 0 00-4.654-.184 3.183 3.183 0 00-.356 4.372l.15.173 5.802 5.689 5.783-5.67a3.185 3.185 0 00-.019-4.402l-.167-.162z" _fill="#01B9CA" fill-rule="evenodd"/>'
  }
})
